import * as eHubApi from "./data.service";

function getInventorySKUList(req) {
  const query = []
  query.push(`customerCode=${req.customerCode}`)
  query.push(`status=${req.status}`)
  query.push(`kitType=${req.kitType}`)
  if (Boolean(req.skuCodes)){
    const skuCodes = req.skuCodes.split(',', 10).map(x => encodeURIComponent(x.trim())).join("&skuCodes=");
    query.push(`skuCodes=` + skuCodes)
  }
  const queryString = query.join("&");
  return eHubApi.get(
    // `/api/inventory/sku-list?customerCode=${req.customerCode}&status=${req.status}&kitType=${req.kitType}`
    `/api/inventory/sku-list?${queryString}`
  );
}

function getInventorySKU(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(`/api/inventory/sku?customerCode=${req.customerCode}&skuCode=${skuCode}`);
}

function getLocationDetails(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(
    `/api/inventory/location-details?customerCode=${req.customerCode}&skuCode=${skuCode}`
  );
}

function getSKUStockMovement(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(
    `/api/inventory/sku-stock-movement?customerCode=${req.customerCode}&skuCode=${skuCode}&warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&locationID=${req.locationID}&startDate=${req.startDate}&endDate=${req.endDate}`
  );
}

export function getTest1() {
  return eHubApi.get(
    `/api/inventory/test3`
  );
}

export const inventorySync = (req) => eHubApi.post("/api/inventory/sync",req);

function getInventoryLocationList(req) {
  return eHubApi.get(`/api/inventory/location-list?customerCode=${req.customerCode}`);
}

function getInventoryLocation(req) {
  return eHubApi.get(
    `/api/inventory/location?customerCode=${req.customerCode}&warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&locationID=${req.locationID}`
  );
}

function getSKUDetails(req) {
  return eHubApi.get(
    `/api/inventory/sku-details?customerCode=${req.customerCode}&warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&locationID=${req.locationID}`
  );
}

function getLocationStockMovement(req) {
  return eHubApi.get(
    `/api/inventory/location-stock-movement?customerCode=${req.customerCode}&warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&locationID=${req.locationID}&startDate=${req.startDate}&endDate=${req.endDate}`
  );
}

function exportSKUStockMovement(req) {
  return eHubApi.post_file("/api/inventory/export-sku", req);
}
function exportLocationStockMovement(req) {
  return eHubApi.post_file("/api/inventory/export-location", req);
}

function editStockAttributes(req) {
  return eHubApi.post("/api/stockAttributes/create", req)
}
function getStockAttributes(req) {
  return eHubApi.get(`/api/stockAttributes/get?stockAttributesNo=${req.stockAttributesNo}&customerCode=${req.customerCode}`);
}
function getStockAttributesList(req) {
  return eHubApi.get(`/api/stockAttributes/list?customerCode=${req.customerCode}`);
}



export const activeAdjustmentReason=(req) => eHubApi.put(`/api/adjustmentReasonCode/activate?reasonCode=${req.reasonCode}`)
export const getAdjustmentReasonStatusCount=() => eHubApi.get("/api/adjustmentReasonCode/get-status-count")

//Stock Transfer
function getPalletOptions(req) {
  return eHubApi.post("/api/inventory/palletOptions", {
    customerCode: req.customerCode,
    warehouseCode: req.warehouseCode,
    zoneID: req.zoneID,
    locationID: req.locationID,
    skuCode: req.skuCode,
  });
}
function createStockTransfer(req) {
  return eHubApi.post("/api/stockTransfer/create", req)
}
function getStockTransfer(req) {
  return eHubApi.get(`/api/stockTransfer/get?stockTransferNo=${req.stockTransferNo}&customerCode=${req.customerCode}`);
}
function getStockTransferList(req) {
  return eHubApi.get(`/api/stockTransfer/list?customerCode=${req.customerCode}`);
}

function createInterDivisionStockTransfer(req) {
  return eHubApi.post("/api/InterDivisionStockTransfer/create", req)
};

function getInterDivisionStockTransfer(req) {
  return eHubApi.get(`/api/InterDivisionStockTransfer/get?stockTransferNo=${req.stockTransferNo}&customerCode=${req.customerCode}`);
};

function getInterDivisionStockTransferList(req) {
  return eHubApi.get(`/api/InterDivisionStockTransfer/list?customerCode=${req.customerCode}`);
};

function getCustomerCode() {
  return eHubApi.get("/api/inventory/customer-list");
}

function getVendorCodeFromCustomer(req) {
  return eHubApi.get(`/api/vendor/options?customerCode=${req.customerCode}`);
}

function getZone(req) {
  return eHubApi.get(`/api/zone/list-by-customer?active=${req.active}&customerCode=${req.customerCode}`);
}

function getLocation(req) {
  return eHubApi.get(`/api/location/list-by-customer-zone?active=${req.active}&customerCode=${req.customerCode}`);
}

function getOLN(req) {
  return eHubApi.get(`/api/inventory/oln-list?customerCode=${req.customerCode}`);
}

function getPhysicalNoList(customerCode) {
  return eHubApi.get(`/api/inventory/physical-no-list?customerCode=${customerCode}`);
}

function getMLN(req) {
  return eHubApi.get(`/api/inventory/mln-list?customerCode=${req.customerCode}`);
}

function getCartonID(req) {
  return eHubApi.get(`/api/inventory/carton-id-list?customerCode=${req.customerCode}`);
}
function getDistinctSKUCode(req){
  let url = `/api/inventory/get-distinct-sku-code-by-customer-vendor?customerCode=${req.customerCode}`;

  if (req.selectedVendor) {
    url += `&vendorCode=${req.selectedVendor}`;
  }

  return eHubApi.get(url);
  //return eHubApi.get(`/api/inventory/get-distinct-sku-code-by-customer-vendor?customerCode=${req.customerCode}&vendorCode=${req.vendorCode}`);
}

function getDistinctSKUCategory(req){
  let url = `/api/inventory/get-distinct-category-by-customer-vendor?customerCode=${req.customerCode}`;

  if (req.selectedVendor) {
    url += `&vendorCode=${req.selectedVendor}`;
  }

  return eHubApi.get(url);
  //return eHubApi.get(`/api/inventory/get-distinct-category-by-customer-vendor?customerCode=${req.customerCode}&vendorCode=${req.vendorCode}`);
}

function getDistinctSKUGroup(req){
  let url = `/api/inventory/get-distinct-sku-group-by-customer-vendor?customerCode=${req.customerCode}`;

  if (req.selectedVendor) {
    url += `&vendorCode=${req.selectedVendor}`;
  }

  return eHubApi.get(url);
  //return eHubApi.get(`/api/inventory/get-distinct-sku-group-by-customer-vendor?customerCode=${req.customerCode}&vendorCode=${req.vendorCode}`);
}

function getDistinctSKUSubgroup(req){
  let url = `/api/inventory/get-distinct-sku-subgroup-by-customer-vendor?customerCode=${req.customerCode}`;

  if (req.selectedVendor) {
    url += `&vendorCode=${req.selectedVendor}`;
  }

  return eHubApi.get(url);
  //return eHubApi.get(`/api/inventory/get-distinct-sku-subgroup-by-customer-vendor?customerCode=${req.customerCode}&vendorCode=${req.vendorCode}`);
}

function getPhysicalCountList(){
  let url = `/api/inventory/generate-physical-count-exceptional-list`;

  // if (req.selectedVendor) {
  //   url += `&vendorCode=${req.selectedVendor}`;
  // }

  return eHubApi.get(url);
  //return eHubApi.get(`/api/inventory/generate-physical-count-exceptional-list?customerCode=${req.customerCode}&vendorCode=${req.vendorCode}&zone=${req.zone}&location=${req.location}&oln=${req.oln}&mln=${req.mln}&cartonID=${req.cartonID}`);
}

function getPhysicalCountList2(req){
  //console.log("reqinphysicalcountlist",req);
  const cleanReq = {
  ...req,
  locationID: Array.isArray(req.locationID)
    ? req.locationID
    : req.locationID?.split(",").map(x => x.trim()),

  vendorCode: req.vendorCode ?? [],
  zoneID: req.zoneID ?? [],
  skuCode: req.skuCode ?? [],
  category: req.category ?? [],
  skuGroup: req.skuGroup ?? [],
  skuSubGroup: req.skuSubGroup ?? [],
  oln: req.oln ?? [],
  mln: req.mln ?? [],
  cartonID: req.cartonID ?? []
};
  return eHubApi.post("/api/inventory/test-exceptional", cleanReq);
//let url = `/api/inventory/test-exceptional?customerCode=${req.customerCode}&vendorCode=${req.vendorCode}&zoneID=${req.zoneID}&locationID=${req.locationID}&skuCode=${req.skuCode}&category=${req.category}&skuGroup=${req.skuGroup}&skuSubgroup=${req.skuSubgroup}&oln=${req.oln}&mln=${req.mln}&cartonID=${req.cartonID}&freeze=${req.freeze}&showSystemQuantity=${req.showSystemQuantity}&hold=${req.hold}`;
// let url = `/api/inventory/test-exceptional?customerCode=${encodeURIComponent(req.customerCode)}&vendorCode=${encodeURIComponent(req.vendorCode)}&zoneID=${encodeURIComponent(req.zoneID)}&locationID=${encodeURIComponent(req.locationID)}&skuCode=${encodeURIComponent(req.skuCode)}&category=${encodeURIComponent(req.category)}&skuGroup=${encodeURIComponent(req.skuGroup)}&skuSubgroup=${encodeURIComponent(req.skuSubgroup)}&oln=${encodeURIComponent(req.oln)}&mln=${encodeURIComponent(req.mln)}&cartonID=${encodeURIComponent(req.cartonID)}&freeze=${encodeURIComponent(req.freeze)}&showSystemQuantity=${encodeURIComponent(req.showSystemQuantity)}&hold=${encodeURIComponent(req.hold)}`;
//   return eHubApi.post(url)
  // .then(response => {
  //   // Process the response from the first API call
  //  console.log(response);
  //   const PCountNo = response.data.PCountNo;
  //   console.log("entering to export physical count list");
  //   console.log(PCountNo);
  //   // Call the second API
  //   return eHubApi.post(`/api/inventory/export-physical-count-list`, { PCountNo });
  // });
  //return eHubApi.get(`/api/inventory/generate-physical-count-exceptional-list?customerCode=${req.customerCode}&vendorCode=${req.vendorCode}&zone=${req.zone}&location=${req.location}&oln=${req.oln}&mln=${req.mln}&cartonID=${req.cartonID}`);
}

function retrievePhysicalCountList(PCountNo){
  let url = `/api/inventory/export-physical-count-list?PCountNo=${PCountNo}`;
  
    return eHubApi.post_file(url)
  }

  function retrievePhysicalCountListOnly(PCountNo){
    let url = `/api/inventory/export-physical-count-list-only?PCountNo=${PCountNo}`;
    
      return eHubApi.post_file(url)
    }

    function retrievePhysicalCountException(){
      let url = `/api/inventory/export-physical-count-exception-only`;
      
        return eHubApi.post_file(url)
      }
/////////////////////////////////
function getCycleNoList(customerCode) {
  return eHubApi.get(`/api/cycle-count/cycle-no-list?customerCode=${customerCode}`);
}

function getCycleCountList(){
  let url = `/api/cycle-count/generate-cycle-count-exceptional-list`;

  // if (req.selectedVendor) {
  //   url += `&vendorCode=${req.selectedVendor}`;
  // }

  return eHubApi.get(url);
  //return eHubApi.get(`/api/inventory/generate-physical-count-exceptional-list?customerCode=${req.customerCode}&vendorCode=${req.vendorCode}&zone=${req.zone}&location=${req.location}&oln=${req.oln}&mln=${req.mln}&cartonID=${req.cartonID}`);
}

function getCycleCountList2(req){
//let url = `/api/cycle-count/test-exceptional?customerCode=${req.customerCode}&vendorCode=${req.vendorCode}&zoneID=${req.zoneID}&locationID=${req.locationID}&skuCode=${req.skuCode}&category=${req.category}&skuGroup=${req.skuGroup}&skuSubgroup=${req.skuSubgroup}&oln=${req.oln}&mln=${req.mln}&cartonID=${req.cartonID}&freeze=${req.freeze}&showSystemQuantity=${req.showSystemQuantity}&hold=${req.hold}`;
let url = `/api/cycle-count/test-exceptional?customerCode=${encodeURIComponent(req.customerCode)}&vendorCode=${encodeURIComponent(req.vendorCode)}&zoneID=${encodeURIComponent(req.zoneID)}&locationID=${encodeURIComponent(req.locationID)}&skuCode=${encodeURIComponent(req.skuCode)}&category=${encodeURIComponent(req.category)}&skuGroup=${encodeURIComponent(req.skuGroup)}&skuSubgroup=${encodeURIComponent(req.skuSubgroup)}&oln=${encodeURIComponent(req.oln)}&mln=${encodeURIComponent(req.mln)}&cartonID=${encodeURIComponent(req.cartonID)}&freeze=${encodeURIComponent(req.freeze)}&showSystemQuantity=${encodeURIComponent(req.showSystemQuantity)}&hold=${encodeURIComponent(req.hold)}`;

  return eHubApi.post(url)
  // .then(response => {
  //   // Process the response from the first API call
  //  console.log(response);
  //   const PCountNo = response.data.PCountNo;
  //   console.log("entering to export physical count list");
  //   console.log(PCountNo);
  //   // Call the second API
  //   return eHubApi.post(`/api/inventory/export-physical-count-list`, { PCountNo });
  // });
  //return eHubApi.get(`/api/inventory/generate-physical-count-exceptional-list?customerCode=${req.customerCode}&vendorCode=${req.vendorCode}&zone=${req.zone}&location=${req.location}&oln=${req.oln}&mln=${req.mln}&cartonID=${req.cartonID}`);
}

function retrieveCycleCountList(CCountNo){
  let url = `/api/cycle-count/export-cycle-count-list?CCountNo=${CCountNo}`;
  
    return eHubApi.post_file(url)
  }

  function retrieveCycleCountListOnly(CCountNo){
    let url = `/api/cycle-count/export-cycle-count-list-only?CCountNo=${CCountNo}`;
    
      return eHubApi.post_file(url)
    }

    function retrieveCycleCountException(){
      let url = `/api/cycle-count/export-cycle-count-exception-only`;
      
        return eHubApi.post_file(url)
      }

        function uploadCC(req) {
          return eHubApi.post("/api/cycle-count/upload", req);
        }
        
        function getCycOpnBalScan(req) {
          return eHubApi.get(`/api/cycle-count/get-cyc-opn-bal-scan?CCountNo=${req.cnos}&customerCode=${req.customerCode}`);
        }
        
        function getCycOpnBalScanComparison(req) {
          return eHubApi.get(`/api/cycle-count/get-cyc-opn-bal-scan-comparison?CCountNo=${req.cnos}&type=${req.type}&customerCode=${req.customerCode}`);
        }
        
        function getCycOpnBalScan3(req) {
          return eHubApi.get(`/api/cycle-count/get-cyc-opn-bal-scan3?CCountNo=${req.cnos}&customerCode=${req.customerCode}`);
        }
        
        function uploadCycOpnBalScanComparison(req) {
          return eHubApi.post(`/api/cycle-count/get-cyc-opn-bal-scan-comparison2?CCountNo=${req.cnos}&type=${req.type}&customerCode=${req.customerCode}&action=UPLOAD`);
        }
        
        function updateCCountList(req) {
          return eHubApi.post("/api/cycle-count/update", req);
        }
        
        function updateFinalCCountList(req) {
          return eHubApi.post("/api/cycle-count/update-final-count-list", req);
        }
        
        function ccforceclose(req) {
          return eHubApi.post(`/api/cycle-count/forceclose?CCountNo=${req.cnos}&customerCode=${req.customerCode}`);
        }
        
        function ccconsolidate(req) {
          return eHubApi.post(`/api/cycle-count/consolidate?CCountNo=${req.cnos}&customerCode=${req.customerCode}&reasoncode=${req.reasonCode}`);
        }

function getCycleCountVarReport(req){
  return eHubApi.get(`/api/cycle-count/cycle-count-variance?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

function getCycleCountVarReportDetails(req){
  return eHubApi.get(`/api/cycle-count/cycle-count-variance-details?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

function getCycleCountVarianceComparison(req){
  return eHubApi.get(`/api/cycle-count/cycle-count-variance-comparison?customerCode=${req.customerCode}`)
}

function closeCycleCountVarianceComparison(req){
  return eHubApi.post(`/api/cycle-count/close-variance-comparison`, {
    customerCode: req.customerCode,
    items: req.items,
  })
}

function getCycleCountReport(req){
  return eHubApi.get(`/api/cycle-count/cycle-count-report?customercode=${encodeURIComponent(req.customerCode)}`)
}

function saveCycleCountReportReason(req){
  return eHubApi.post(`/api/cycle-count/save-cycle-count-report-reason`, req)
}

function closeCycleCountReport(req){
  return eHubApi.post(`/api/cycle-count/close-cycle-count-report`, req)
}

function getReconsolidateCycleCountReportPreview(req){
  return eHubApi.post(`/api/cycle-count/reconsolidate-cycle-count-report-preview`, req)
}

function reconsolidateCycleCountReport(req){
  return eHubApi.post(`/api/cycle-count/reconsolidate-cycle-count-report`, req)
}

function exportCycleCountReport(req){
  return eHubApi.get(
    `/api/cycle-count/export-cycle-count-report?customercode=${encodeURIComponent(req.customerCode)}&format=${req.format}`,
    { responseType: "blob" }
  )
}
//////////////////////////////////////////
function getTAExceptional(req){
  return eHubApi.get(`/api/task-assignment/generate-physical-count-exceptional-list?customerCode=${req.customerCode}&exceptionalType=${req.exceptionalType}`);
}

function getCommonInventoryList(req) {
  const query = [];
  if (req.warehouseCode) query.push(`warehouseCode=${req.warehouseCode}`);
  if (req.zoneID) query.push(`zoneID=${req.zoneID}`);
  if (req.locationID) query.push(`locationID=${req.locationID}`);
  if (req.customerCode) query.push(`customerCode=${req.customerCode}`);
  if (req.vendorCode) query.push(`vendorCode=${req.vendorCode}`);
  if (req.skuCode) query.push(`skuCode=${req.skuCode}`);
  if (req.cartonID) query.push(`cartonID=${req.cartonID}`);
  if (req.palletNbr) query.push(`palletNbr=${req.palletNbr}`);
  if (req.type) query.push(`type=${req.type}`);
  if (req.holdPallet) query.push(`holdPallet=${req.holdPallet}`);
  if (req.toWarehouseCode) query.push(`toWarehouseCode=${req.toWarehouseCode}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/inventory/inventory-list?` + queryString);
}

function getCustomerByDivision(req){
  return eHubApi.get(`/api/inventory/customer-by-division?customerCode=${req.customerCode}`);
}

function getOpenStockHold(req) {
  return eHubApi.get(`/api/stockHold/open?stockHoldNo=${req.stockHoldNo}&customerCode=${req.customerCode}`);
}

function uploadPC(req) {
  return eHubApi.post("/api/physical-count/upload", req);
}

// function uploadPC(req){
//   // let url = `/api/physical-count/upload`, req;
  
//   //   return eHubApi.post_file(url)d

//     return eHubApi.post_file("/api/physical-count/upload", req);
//   }

function getPhyOpnBalScan(req) {
  return eHubApi.get(`/api/physical-count/get-phy-opn-bal-scan?PCountNo=${req.pnos}&customerCode=${req.customerCode}`);
}

function getPhyOpnBalScanComparison(req) {
  return eHubApi.get(`/api/physical-count/get-phy-opn-bal-scan-comparison?PCountNo=${req.pnos}&type=${req.type}&customerCode=${req.customerCode}`);
}

function getPhyOpnBalScan3(req) {
  return eHubApi.get(`/api/physical-count/get-phy-opn-bal-scan3?PCountNo=${req.pnos}&customerCode=${req.customerCode}`);
}

function uploadPhyOpnBalScanComparison(req) {
  return eHubApi.post(`/api/physical-count/get-phy-opn-bal-scan-comparison2?PCountNo=${req.pnos}&type=${req.type}&customerCode=${req.customerCode}&action=UPLOAD`);
}

function updateCountList(req) {
  return eHubApi.post("/api/physical-count/update", req);
}

function updateFinalCountList(req) {
  return eHubApi.post("/api/physical-count/update-final-count-list", req);
}

function insertnewCountList(req) {
   console.log("Sending payload:", req);
  return eHubApi.post("/api/physical-count/insertnewpcountlist", req);
}

function forceclose(req) {
  return eHubApi.post(`/api/physical-count/forceclose?PCountNo=${req.pnos}&customerCode=${req.customerCode}`);
}

function consolidate(req) {
  return eHubApi.post(`/api/physical-count/consolidate?PCountNo=${req.pnos}&customerCode=${req.customerCode}&reasoncode=${req.reasonCode}`);
}

function generateReplenishment(req){
  let url = `/api/replenishment/replenish?customerCode=${req.customerCode}&skuCode=${req.skuCode}&category=${req.category}&skuGroup=${req.skuGroup}&skuSubgroup=${req.skuSubgroup}&movement=${req.movement}&entireWarehouse=${req.entireWarehouse}&skuOption=${req.skuOption}&threshold=${req.threshold}&movementdate=${req.movementdate}`;
  
    return eHubApi.post(url)
  }

function retrieveReplenishmentList(realReplNo){
let url = `/api/replenishment/get-replenishment-list?replno=${realReplNo}`;

  return eHubApi.get(url)
}

function retrieveCountSummaryLookup(req){
  let url = `/api/physical-count/export-count-summary-lookup?PCountNo=${req.pnos}&type=${req.type}&customerCode=${req.customerCode}`;
  
    return eHubApi.post_file(url)
  }

  function retrievePCountList(req){
  let url = `/api/physical-count/export-pcount-list?PCountNo=${req.pnos}&type=${req.type}&customerCode=${req.customerCode}`;
  
    return eHubApi.post_file(url)
  }

// function retrieveLatestCountList(req){
// let url = `/api/physical-count/export-latest-count-list?PCountNo=${req.pnos}&customerCode=${req.customerCode}`;

//   return eHubApi.post_file(url)
// }
function retrieveLatestCountList(req) {
  let url = `/api/physical-count/export-latest-count-list`;
  return eHubApi.post_file(url, {
    PCountNo: req.pnos,
    CustomerCode: req.customerCode,
    Data: req.data,
  });
}

function retrieveCCountSummaryLookup(req){
let url = `/api/cycle-count/export-count-summary-lookup?CCountNo=${req.cnos}&type=${req.type}&customerCode=${req.customerCode}`;

  return eHubApi.post_file(url)
}

// function retrieveLatestCCountList(req){
// let url = `/api/cycle-count/export-latest-count-list?CCountNo=${req.cnos}&customerCode=${req.customerCode}`;

//   return eHubApi.post_file(url)
// }
function retrieveLatestCCountList(req) {
  let url = `/api/cycle-count/export-latest-count-list`;
  return eHubApi.post_file(url, {
    CCountNo: req.cnos,
    CustomerCode: req.customerCode,
    Data: req.data,
  });
}

function insertnewCCountList(req) {
   console.log("Sending payload:", req);
  return eHubApi.post("/api/cycle-count/insertnewccountlist", req);
}

function retrieveReplenishmentListOnly(ReplNo){
let url = `/api/replenishment/export-replenishment-list-only?ReplNo=${ReplNo}`;

  return eHubApi.post_file(url)
}

function getReplenishmentNoList(customerCode) {
  return eHubApi.get(`/api/replenishment/replenishment-no-list?customerCode=${customerCode}`);
}

function replconsolidate(req) {
  return eHubApi.post("/api/replenishment/consolidate",req);
}

function getadjustmentreasoncode() {
  return eHubApi.get(`/api/adjustmentReasonCode/list?Active=true`);
}

function replforceclose(req) {
  return eHubApi.post(`/api/replenishment/forceclose?ReplNo=${req.replnos}&customerCode=${req.customerCode}`);
}

function updaterepllist(req) {
  return eHubApi.post("/api/replenishment/update-replenishment", req);
}

function getSerialNumberLog(req){
  return eHubApi.get(`/api/inventory/serial-number?id=${req.id}`)
}

function downloadInterDivisionTemplate(req){
  return eHubApi.post_file(`/api/InterDivisionStockTransfer/export-template`, req)
}

function UploadInterDivision(req){
  return eHubApi.post(`/api/InterDivisionStockTransfer/upload`, req);
}

function createDivisionTransfer(req) {
  return eHubApi.post("/api/DivisionTransfer/create", req)
};

function getDivisionTransfer(req) {
  return eHubApi.get(`/api/DivisionTransfer/get?stockTransferNo=${req.stockTransferNo}&customerCode=${req.customerCode}`);
};

function getDivisionTransferList(req) {
  return eHubApi.get(`/api/DivisionTransfer/list?customerCode=${req.customerCode}`);
};
function uploadDivisionTransfer(req){
  return eHubApi.post(`/api/DivisionTransfer/upload`, req);
}
function downloadDivisionTransferTemplate(req){
  return eHubApi.post_file(`/api/DivisionTransfer/export-template`, req)
}

function createDivisionAdjustment(req) {
  return eHubApi.post("/api/DivisionAdjustment/create", req)
};

function getDivisionAdjustmentList(req) {
  return eHubApi.get(`/api/DivisionAdjustment/list?customerCode=${req.customerCode}`);
};

function uploadDivisionAdjustment(req){
  return eHubApi.post(`/api/DivisionAdjustment/upload`, req);
}

function downloadDivisionAdjustmentTemplate(req){
  return eHubApi.post_file(`/api/DivisionAdjustment/export-template`, req)
}

function getDivisionAdjustment(req) {
  return eHubApi.get(`/api/DivisionAdjustment/get?stockTransferNo=${req.stockTransferNo}&customerCode=${req.customerCode}`);
};

function syncDivisionBySKU(req){
  return eHubApi.post(`/api/DivisionTransfer/sync-by-sku`, req)
}
function syncDivisionByCustomer(req){
  return eHubApi.post(`/api/DivisionTransfer/sync-by-customer`, req)
}
function getDivisionCustomers(req){
  return eHubApi.get(`/api/Division/customers?divisionGroup=${req.divisionGroup}`);
}
function getDivisionSKUList(req) {
  const query = []
  query.push(`customerCode=${req.customerCode}`)
  query.push(`status=${req.status}`)
  if (Boolean(req.skuCodes)){
    const skuCodes = req.skuCodes.split(',', 10).map(x => encodeURIComponent(x.trim())).join("&skuCodes=");
    query.push(`skuCodes=` + skuCodes)
  }
  const queryString = query.join("&");
  return eHubApi.get(
    // `/api/inventory/sku-list?customerCode=${req.customerCode}&status=${req.status}&kitType=${req.kitType}`
    `/api/inventory/division-sku-list?${queryString}`
  );
}
function getDivisionInventorySKU(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(`/api/inventory/division-sku?customerCode=${req.customerCode}&skuCode=${skuCode}`);
}

function getDivisionLocationDetails(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(
    `/api/inventory/division-location-details?customerCode=${req.customerCode}&skuCode=${skuCode}`
  );
}

function getDivisionSKUStockMovement(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(
    `/api/inventory/division-sku-stock-movement?customerCode=${req.customerCode}&skuCode=${skuCode}&startDate=${req.startDate}&endDate=${req.endDate}`
  );
}

function validateTransferDivisionUploadData (req){
  return eHubApi.post("/api/StockTransfer/division/validate",req);
} 
function downloadTransferDivisionGroupTemplate(req){
  return eHubApi.post_file(`/api/StockTransfer/download`, req);
}

export {
  getInventorySKUList,
  getInventorySKU,
  getLocationDetails,
  getSKUStockMovement,
  exportSKUStockMovement,
  getInventoryLocationList,
  getInventoryLocation,
  getSKUDetails,
  getLocationStockMovement,
  exportLocationStockMovement,
  editStockAttributes, getStockAttributes, getStockAttributesList,
  getCustomerCode,
  getVendorCodeFromCustomer,
  getZone,
  getLocation,
  getOLN,
  getMLN,
  getCartonID,
  getDistinctSKUCode,
  getDistinctSKUCategory,
  getDistinctSKUGroup,
  getDistinctSKUSubgroup,
  getPhysicalCountList,
  getPhysicalCountList2,
  retrievePhysicalCountList,
  getPhysicalNoList,
  retrievePhysicalCountListOnly,
  retrievePhysicalCountException,
  // getZoneByCustomerVendor,
  // getLocationByCustomerVendor,
  // getAisleByCustomerVendor
  getPalletOptions, createStockTransfer, getStockTransfer, getStockTransferList,
  getCommonInventoryList,
  getOpenStockHold,
  uploadPC,
  getPhyOpnBalScan,
  getPhyOpnBalScanComparison,
  getPhyOpnBalScan3,
  uploadPhyOpnBalScanComparison,
  updateCountList,
  updateFinalCountList,
  forceclose,
  consolidate,
  getCycleCountList,
  getCycleCountList2,
  retrieveCycleCountList,
  getCycleNoList,
  retrieveCycleCountListOnly,
  retrieveCycleCountException,
  uploadCC,
  getCycOpnBalScan,getCycOpnBalScanComparison,getCycOpnBalScan3,uploadCycOpnBalScanComparison,updateCCountList,updateFinalCCountList,
  ccforceclose,ccconsolidate,
  generateReplenishment,
  retrieveReplenishmentList,
  retrieveCountSummaryLookup,
  retrievePCountList,
  retrieveLatestCountList,
  retrieveCCountSummaryLookup,
  retrieveLatestCCountList,
  retrieveReplenishmentListOnly,
  getReplenishmentNoList,
  replconsolidate,
  getadjustmentreasoncode,
  replforceclose,
  updaterepllist,
  getSerialNumberLog,
  getCycleCountVarReport,
  getCycleCountVarReportDetails,
  getCycleCountVarianceComparison,
  closeCycleCountVarianceComparison,
  getCycleCountReport,
  saveCycleCountReportReason,
  closeCycleCountReport,
  getReconsolidateCycleCountReportPreview,
  reconsolidateCycleCountReport,
  exportCycleCountReport,
  getCustomerByDivision,
  getInterDivisionStockTransfer,
  getInterDivisionStockTransferList,
  createInterDivisionStockTransfer,
  downloadInterDivisionTemplate,
  UploadInterDivision,
  getDivisionTransfer,
  getDivisionTransferList,
  createDivisionTransfer,
  uploadDivisionTransfer,
  downloadDivisionTransferTemplate,
  getDivisionAdjustment,
  uploadDivisionAdjustment,
  getDivisionAdjustmentList,
  downloadDivisionAdjustmentTemplate,
  createDivisionAdjustment,
  syncDivisionByCustomer,
  syncDivisionBySKU,
  getDivisionCustomers,
  getDivisionSKUList,
  getDivisionInventorySKU,
  getDivisionLocationDetails,
  getDivisionSKUStockMovement,
  validateTransferDivisionUploadData,
  downloadTransferDivisionGroupTemplate,
  insertnewCountList,insertnewCCountList
};
